<template>
 <div id="account-meta-stage">
  <div class="header mt-5">
   <b class="text-3xl">Você precisa ter uma conta pessoal do Facebook vinculada a conta comercial.</b>
  </div>

  <p class="mt-5 mb-5">Caso já possua uma conta comercial no Facebook, deve autentica-la antes de iniciar o processo de integração.</p>

  <div class="body mt-5">
   <div class="flex">
    <feather-icon icon="ExternalLinkIcon" svgClasses="w-5 h-5" class="p-5"/>
    <p class="align-self-center">Para autenticar sua conta comercial abra <a href="https://www.facebook.com/security/twofactor/reauth/" target="_blank"><b>esse link</b></a> em uma nova guia.</p>
   </div>
   <div class="flex">
    <feather-icon icon="LockIcon" svgClasses="w-5 h-5" class="p-5"/>
    <p class="align-self-center">Agora você deve gerar ou solicitar um código de autenticação e inseri-lo no campo 'Inserir código'.</p>
   </div>
   <div class="flex">
    <feather-icon icon="CheckIcon" svgClasses="w-5 h-5" class="p-5"/>
    <p class="align-self-center">Depois de confirmar, pode fechar a guia do Facebook.</p>
   </div>
  </div>
 </div>
</template>

<script>

export default {
 name: 'account-meta-stage',
 data() {
  return {}
 }
}

</script>

<style scoped lang="scss">

</style>